import { useLocalization } from "@fluent/react";
import { Button, ContentCard } from "@narmi/design_system";
import Filters from "byzantine/src/filters";
import { REVERSAL_REASON_LABELS } from "byzantine/src/dbbl/businessLogic/modules/achPayments";
import type { ReversalReason } from "byzantine/src/dbbl/businessLogic/modules/achPayments";
import styles from "../../DualApproval.module.scss";
import { useBulkAmount } from "./BulkPaymentTopCard";
import type { BulkReversalTopCardProps } from "./types";

const BulkReversalTopCard = ({
  dualApproval,
  handleClickViewPayments,
  handleClickOriginalPayment,
}: BulkReversalTopCardProps) => {
  const { l10n } = useLocalization();

  const bulkAmount = useBulkAmount(dualApproval);

  const reversalReason = dualApproval.payment?.reversalReason
    ? REVERSAL_REASON_LABELS[
        dualApproval.payment.reversalReason as ReversalReason
      ] || dualApproval.payment.reversalReason
    : "—";

  return (
    <div className="margin--top--l">
      <ContentCard kind="bordered">
        <h5 className="fontSize--m fontWeight--normal margin--bottom--xs">
          {l10n.getString("approval-drawer-bulk-reversal-title")}
        </h5>
        <h1 className="fontColor--primary">{bulkAmount}</h1>
        <hr className="margin--bottom--l margin--top--l" />

        <h5 className={styles.drawerLabelHeading}>
          {l10n.getString("label-approval-due-date")}
        </h5>
        <div className="margin--bottom--m">
          {dualApproval.expiredAt
            ? Filters.longMonthDayYear(dualApproval.expiredAt)
            : "—"}
        </div>

        <h5 className={styles.drawerLabelHeading}>
          {l10n.getString("label-reversal-reason")}
        </h5>
        <div className="margin--bottom--m">{reversalReason}</div>

        <h5 className={styles.drawerLabelHeading}>
          {l10n.getString("label-original-payment")}
        </h5>
        <div className="margin--bottom--s">
          <Button
            kind="plain"
            size="s"
            onClick={handleClickOriginalPayment}
            testId="view-original-payment"
          >
            {l10n.getString("view-original-payment-cta")}
            <span className="narmi-icon-chevron-right" />
          </Button>
        </div>

        <h5 className={styles.drawerLabelHeading}>
          {l10n.getString("label-bulk-details")}
        </h5>
        <Button
          kind="plain"
          size="s"
          onClick={handleClickViewPayments}
          disabled={!handleClickViewPayments}
          testId="view-payments"
        >
          {l10n.getString("view-payments-cta", {
            total: dualApproval.bulk?.paymentCount || 0,
          })}
          <span className="narmi-icon-chevron-right" />
        </Button>
      </ContentCard>
    </div>
  );
};

export default BulkReversalTopCard;
